import { Box } from "@mui/material";
import Tag from "../../../../common/components/Tag/Tag";
import { CurtailmentObjectGroupType } from "./CurtailmentObject.types";
import { useMemo, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { style } from "./CurtailmentObject.style";
import CurtailmentObjects from "../../../../common/components/CurtailmentObjects";
import { Link } from "react-router-dom";
import { getPathWithParameters, getPathWithSearchParams, PATH } from "../../../../router-path";
import { TabID } from "../ContractPeriodTabs";

const CurtailmentObjectBySite = ({
	curtailmentObjectGroup,
}: {
	curtailmentObjectGroup: CurtailmentObjectGroupType;
}) => {
	const [isActiveSiteAccordion, setIsActiveSiteAccordion] = useState(false);

	const handleToggleOpen = () => {
		setIsActiveSiteAccordion((currentOpen) => !currentOpen);
	};


		const linkToSiteCurtailmentTab = useMemo(() => {
			return getPathWithSearchParams(getPathWithParameters(PATH.SITE_DETAIL, {
								siteId: curtailmentObjectGroup?.site?.id,
							}), {tab: TabID.CURTAILMENT_OBJECT})
		}, [curtailmentObjectGroup])
	

	return (
		<Box sx={style.wrapper}>
			<Box sx={style.siteBlockHeader}>
				<Box onClick={handleToggleOpen} sx={style.siteBlockHandler}>
					{isActiveSiteAccordion ? (
						<KeyboardArrowUpIcon />
					) : (
						<KeyboardArrowDownIcon />
					)}
					<Box sx={style.siteName}>
						<Link to={linkToSiteCurtailmentTab}>{curtailmentObjectGroup?.site?.name}</Link>
						
						</Box>
				</Box>
				{!isActiveSiteAccordion && (
					<Box sx={style.tagsWrapper}>
						{curtailmentObjectGroup?.curtailmentKinds.map(
							(curtailmentKind) => (
								<Tag
									key={curtailmentKind}
									label={curtailmentKind}
								/>
							)
						)}
					</Box>
				)}
			</Box>
			{isActiveSiteAccordion && (
				<CurtailmentObjects
					curtailmentObjectGroup={curtailmentObjectGroup}
				/>
			)}
		</Box>
	);
};

export default CurtailmentObjectBySite;
